import { createTheme } from '@mui/material';

const appThemeV1 = createTheme({
    palette: {
        primary: {
            main: '#6025D8FF',
        },
    },
    components: {
        MuiDialog: {
            styleOverrides: {
                root: {
                    '& .MuiBackdrop-root': {
                        WebkitBackdropFilter: 'blur(8px)',
                        backdropFilter: 'blur(8px)',
                        backgroundColor: '#00000080',
                    },
                },
            },
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                },
            },
        },
    },
});

export default appThemeV1;
